var _defs, _path, _path2, _path3, _path4, _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew287({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,8.83V6.68h.61a1,1,0,0,1,.34,0,.61.61,0,0,1,.27.19,1,1,0,0,1,.17.34,1.77,1.77,0,0,1,.06.49,1.61,1.61,0,0,1-.1.62.7.7,0,0,1-.28.36.79.79,0,0,1-.44.11Zm.23-.26h.38a.64.64,0,0,0,.34-.07.45.45,0,0,0,.18-.24,1.35,1.35,0,0,0,.08-.52,1.18,1.18,0,0,0-.08-.51A.47.47,0,0,0,12.87,7a.71.71,0,0,0-.3-.05H12.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.79,8.83v-.3H14v.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.26,8V7.73H16v.8a1.38,1.38,0,0,1-.36.25.8.8,0,0,1-.37.08.88.88,0,0,1-.46-.12.92.92,0,0,1-.32-.38,1.4,1.4,0,0,1-.12-.6,1.44,1.44,0,0,1,.12-.61.85.85,0,0,1,.31-.38.77.77,0,0,1,.45-.13.89.89,0,0,1,.34.07.61.61,0,0,1,.24.21,1,1,0,0,1,.14.36l-.21.07a.69.69,0,0,0-.11-.27.39.39,0,0,0-.17-.14.46.46,0,0,0-.23-.05.58.58,0,0,0-.33.09.62.62,0,0,0-.23.29,1.34,1.34,0,0,0-.08.48,1,1,0,0,0,.18.64.57.57,0,0,0,.47.22.61.61,0,0,0,.28-.07.66.66,0,0,0,.23-.15V8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1.47,3.62h8.76a0,0,0,0,1,0,0V8a4.38,4.38,0,0,1-4.38,4.38h0A4.38,4.38,0,0,1,1.47,8V3.62a0,0,0,0,1,0,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 5.86,
    cy: 8.06,
    r: 2.35
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: -0.01,
    y1: 3.62,
    x2: 11.72,
    y2: 3.62
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew287);
export default __webpack_public_path__ + "static/media/Symbolpack_New_287.a307f5ac5802fe9a7a2638d0124bb0d4.svg";
export { ForwardRef as ReactComponent };